import { useState } from "react";
import styles from './SingleSelectorDialogBox.module.css';
import SingleSelectSearchableDropdown from "../SingleSelectSearchableDropdown/SingleSelectSearchableDropdown";

const SingleSelectorDialogBox = ({
    listOptions,
    handleOptionSelect,
    setShowSelector,
    primaryText,
    ctaText,
    optionIcon,
    dialogTitle,
    errorMessage = null
}) => {
    
    const [currentlySelectedAccount, setCurrentlySelectedOption] = useState(null);

    const handleUserSelection = (option) => {
        // setShowSelector(false);
        setCurrentlySelectedOption(option);
    };

    const handleConfirm = () => {
        if (currentlySelectedAccount) {
            handleOptionSelect(currentlySelectedAccount);
        }
    };

    const handleCancel = () => {
        setShowSelector(false);
    };

    // Transform listOptions array to dropdown options format
    const optionDetais = listOptions.map(option => ({
        ...option,
        id: option.id,
        displayText: option.displayName,
        label: option.label,
        iconText: option.iconText
    }));

    return (
        <>
            <div className={styles.overlay} onClick={handleCancel} />
            <div className={styles.dialog}>
                <div className={styles.dialogHeader}>
                    <h3 className={styles.dialogTitle}>{ dialogTitle }</h3>
                </div>
                <div className={styles.dialogContent}>
                    <p className={styles.dialogDescription}>
                        { primaryText }
                    </p>
                    {
                        errorMessage ?
                            <p className={styles.errorMessage}>{ errorMessage }</p> :
                            <div className={styles.dropdownWrapper}>
                                <SingleSelectSearchableDropdown
                                    fieldDisplayText="Select an option"
                                    maxWidth={100}
                                    maxWidthUnit="%"
                                    listOptions={optionDetais}
                                    labelPosition="BELOW"
                                    setSelectedOption={handleUserSelection}
                                />
                            </div>
                    }
                </div>
                <div className={styles.dialogFooter}>
                    <button className={styles.cancelButton} onClick={handleCancel}>
                        Cancel
                    </button>
                    {
                        !errorMessage &&
                        <button
                            className={styles.confirmButton}
                            onClick={handleConfirm}
                            disabled={!currentlySelectedAccount}
                        >
                            { ctaText }
                        </button>
                    }
                </div>
            </div>
        </>
    );
}

export default SingleSelectorDialogBox;